// actions.js
// this is an action creator button 
// '../store/actions/actions.js
export const updateButtonPercent = (id, newPercent) => {
    return { type: 'UPDATE_BUTTON_PERCENT', payload: { id, newPercent }};
};
  